import styled from "styled-components";
import { withFormik } from "formik";
import type { FormikProps } from "formik";
import * as Yup from "yup";
import { LoginFormValues } from "../../store/userSlice";
import { useAppSelector } from "../../store";
import { ApiResult, LoadingStatus } from "../../lib/types";
import WaitAnimation from "../Common/Wait";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";

interface MyFormProps {
  initialUserid?: string;
  initialPassword?: string;
  onLogin: (values: LoginFormValues) => void;
}

const InnerForm = (props: FormikProps<LoginFormValues>) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = props;

  const loginStatus = useAppSelector((state) => state.user.loginStatus);
  const apiResult = useAppSelector((state) => state.user.apiResult);

//   const Container = styled.div`
//   width: 20rem;

//   h1 {
//     margin-bottom: 20px;
//     font-size: 1.5rem;
//     text-align: center;
//     color: #666;
//   }

//   input {
//     width: 100%;
//     padding: 12px;
//     box-sizing: border-box;
//     margin-bottom: 5px;
//     border: 1px solid #ccc;
//   }

//   button {
//     width: 100%;
//     padding: 12px;
//     margin-top: 10px;
//     border: none;
//     background-color: orange;
//     position: relative;
//   }
// `;  
  return (
    <div>
      <h1 className="text-base font-semibold text-center w-full pb-4 text-gray-700">
        계정으로 로그인
      </h1>
      <form onSubmit={handleSubmit} className="text-center w-full flex flex-col gap-2">
        <Input
          className="w-full h-11"
          type="text"
          name="userid"
          placeholder="사용자 아이디"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.userid}
        />
        {touched.userid && errors.userid ? (
          <div className="text-[#d05555] mb-2 text-sm text-left">{errors.userid}</div>
        ) : null}
        <Input
          className="w-full h-11"
          type="password"
          name="password"
          placeholder="비밀번호"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
        />
        {touched.password && errors.password ? (
          <div className="text-[#d05555] mb-2 text-sm text-left">{errors.password}</div>
        ) : null}
        <Button
          type="submit"
          variant="primary"
          className="w-full mt-2 h-11"
          disabled={
            isSubmitting ||
            !!(errors.userid && touched.userid) ||
            !!(errors.password && touched.password)
          }
        >
          {loginStatus === LoadingStatus.PENDING && (
            <WaitAnimation left="100px" top="4px" />
          )}
          로그인
        </Button>
        {apiResult === ApiResult.NOT_EXIST && (
          <div className="text-[#d05555] mb-2 text-sm text-left">잘못된 아이디나 비밀번호입니다</div>
        )}
        {apiResult === ApiResult.UNKNOWN_ERROR && (
          <div className="text-[#d05555] mb-2 text-sm text-left">서버에 연결할 수 없습니다</div>
        )}
      </form>
    </div>
  );
};

const LoginForm = withFormik<MyFormProps, LoginFormValues>({
  mapPropsToValues: (props) => ({
    userid: props.initialUserid || "",
    password: props.initialPassword || "",
  }),

  validationSchema: Yup.object().shape({
    userid: Yup.string().required("사용자 아이디를 입력하세요"),
    password: Yup.string().required("비밀번호를 입력하세요"),
  }),

  handleSubmit(
    values: LoginFormValues,
    { props, setSubmitting, setErrors, submitForm }
  ) {
    props.onLogin(values);
    setSubmitting(false);
  },
})(InnerForm);

const Container = styled.div`
  width: 20rem;

  h1 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    text-align: center;
    color: #666;
  }

  input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border: 1px solid #ccc;
  }

  button {
    width: 100%;
    padding: 12px;
    margin-top: 10px;
    border: none;
    background-color: orange;
    position: relative;
  }
`;
const LoginErrorMessage = styled.div`
  color: #d05555;
`;

export default LoginForm;
